import { useTranslation } from "react-i18next";
import useMmcService from "../../services/MmcService";
import React, { useContext } from "react";
import InitContext from "../pages/InitContext";
import ErrorMessage from "../errorMessage/ErrorMessage";
import Spinner from "../spinner/Spinner";
import {Consts} from "../pages/consts";
import {faXmark} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

const RequestDataDeleteDialog = ({
  showDialog,
  onConfirmRequestDataDelete,
  onCancelRequestDataDelete,
}) => {
  const { t } = useTranslation();

  const { loading, error, clearError, requestDbPatientDataDelete } =
    useMmcService();

  const context = useContext(InitContext);

  const handleRequestDataDelete = async () => {
    clearError();

    const res = await requestDbPatientDataDelete(
      context?.token,
      context?.patient?.id,
    );

    if (res) {
      onConfirmRequestDataDelete();
    } else {
      console.error("request patient data delete failed");
    }
  };

  const errorMessage = error && <ErrorMessage message={error} />;
  const spinner = loading && <Spinner />;

  return (
    <div
      className="w3-modal feedback-modal"
      style={{ display: showDialog ? Consts.BLOCK : Consts.NONE }}
    >
      <div className="w3-modal-content feedback-modal-content">
        <header className="feedback-modal-header">
          <h2>{t("request_delete_my_data")}</h2>
          <FontAwesomeIcon
            icon={faXmark}
            className="modal-close"
            onClick={onCancelRequestDataDelete}
          />
        </header>
        {errorMessage}
        {spinner}
        <div className="w3-container w3-padding-small w3-margin">
          <label className="w3-block w3-left-align">
            {t("request_delete_my_data_info1")}{" "}
            {t("request_delete_my_data_info2")}{" "}
            {t("request_delete_my_data_info3")}
          </label>
          <label className="w3-margin-top">{t("are_you_sure")}</label>
        </div>
        <footer className="feedback-modal-buttons">
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5"
              onClick={handleRequestDataDelete}
            >
              {t("yes")}
            </button>
            <button
              className="w3-btn w3-round-xlarge w3-theme-d5 w3-right"
              onClick={onCancelRequestDataDelete}
            >
              {t("no")}
            </button>
        </footer>
      </div>
    </div>
  );
};

export default RequestDataDeleteDialog;
